import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../../molecules/switch-box';

export const SettingsWbInstall = () => {
  return (
    <SwitchBox
      title={
        <FormattedMessage
          id="settings.wallbox.install"
          defaultMessage="Wallbox aktivní"
        />
      }
      switchVariableId="WB_INSTALL"
      fullWidth
    />
  );
};
